import { Pipe, PipeTransform } from '@angular/core';
import { MetaTagsService } from 'src/app/services/meta-tags.service';

@Pipe({
  name: 'pinterest'
})
export class PinterestPipe implements PipeTransform {

  constructor(
    private MetaTagsService: MetaTagsService
  ) { }

  transform(link: string, metaData: any): string {
    const pageMetaData = this.MetaTagsService.getPageMetaTags();
    return encodeURI(`http://pinterest.com/pin/create/button/?url=${pageMetaData?.url}&media=${pageMetaData?.img}&description=${pageMetaData?.title}`);
  }

}